import dayjs from 'dayjs';

export const setFirstDayOfMonth = (date: Date) => {
  return dayjs(date).startOf('month').toDate();
};
